/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateClinicPathwayDto } from '../../models/create-clinic-pathway-dto';
import { ResponseClinicPathwayDto } from '../../models/response-clinic-pathway-dto';

export interface ClinicPathwaysControllerCreate$Params {
      body: CreateClinicPathwayDto
}

export function clinicPathwaysControllerCreate(http: HttpClient, rootUrl: string, params: ClinicPathwaysControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseClinicPathwayDto>> {
  const rb = new RequestBuilder(rootUrl, clinicPathwaysControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseClinicPathwayDto>;
    })
  );
}

clinicPathwaysControllerCreate.PATH = '/thalea-pathways/clinic-pathways';
